// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Results_wrapper__l9vX0","image":"Results_image__1IJ_B","meta":"Results_meta__4Nzl1","title":"Results_title__sz_SF","readMore":"Results_readMore__ccyDY"};